import { useState, useEffect,useRef, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent } from 'Assessment/src/components/ui/card';
import { Button } from 'Assessment/src/components/ui/button';
import { ScenarioCard } from 'Assessment/src/components/ScenarioCard';
import { AudioRecorder } from 'Assessment/src/components/AudioRecorder';
import { TranscriptCard } from 'Assessment/src/components/TranscriptCard';
import { RecordingInstructions } from 'Assessment/src/components/RecordingInstructions';
import { SuccessOverlay } from 'Assessment/src/components/SuccessOverlay';
import { EvaluationResults } from 'Assessment/src/components/EvaluationResults';
import { useAssessmentSession } from 'Assessment/src/hooks/useAssessmentSession';
import { assessmentStt, assessmentValidate, assessmentUpdate, assessmentGet, assessmentEvaluate } from 'utils/assessmentApplication/assessmentService';
import { toast } from 'sonner';
import { createGamePlayHistory, activityUpdate } from 'utils/gameApplication/gameActivityService';
import { useColor } from "components/ui/ColorContext";
import { ScoreContext } from 'views/game/demoplay/GamePreview';
import { updatePostAssessmentBlock } from 'views/game/demoplay/common';
const PostTraining = ({  AssignId, Activitydata,seconds,
setActivitydata,formData, learnerPlayList, data, contentByLanguage, onComplete,currentQuestNo,questState }: { 
currentQuestNo?:any;
seconds?: any;
   Activitydata?:any;
 setActivitydata?:any;
  formData?: any, 
  learnerPlayList?: any,
  data?: any,
  contentByLanguage?: string | null;
  onComplete?: () => void;
  questState?:any;
  AssignId?:any;
} = {}) => {
   const { learner_game_play_id } = useParams();
     const { profile, setProfile,setlearnerActivityrec,deviceInfo } = useContext(ScoreContext);
  const { session, loading, loadSession } = useAssessmentSession(formData, learnerPlayList,currentQuestNo);
const { primaryColor } = useColor();
  const lastSavedAssessmentIdRef = useRef<string | null>(null);
  // Recording state
  const [audioBlob, setAudioBlob] = useState<Blob | null>(null);
  const [transcript, setTranscript] = useState('');
  const [wordCount, setWordCount] = useState(0);
  const [attempts, setAttempts] = useState(0);
  const [isValid, setIsValid] = useState<boolean | undefined>(undefined);
  const [validationMessage, setValidationMessage] = useState('');

  // Processing state
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [processingProgress, setProcessingProgress] = useState(0);
  const [processingStage, setProcessingStage] = useState<'transcribing' | 'validating' | 'saving'>('transcribing');

  // UI state
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [showSuccessOverlay, setShowSuccessOverlay] = useState(false);
  const [showEvaluationLoading, setShowEvaluationLoading] = useState(false);
  const [isCurrentlyRecording, setIsCurrentlyRecording] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [evaluationData, setEvaluationData] = useState<any>(null);

  useEffect(() => {
    loadSession();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleRecordingComplete = (blob: Blob) => {
    setAudioBlob(blob);
  };

  const handleRecordingStop = (blob: Blob) => {
   
    setAudioBlob(blob);
    processRecording(blob);
  };

  const buildAttemptEntry = (
    attemptNumber: number,
    transcriptText: string,
    isValidEntry: boolean,
    validationMsg: string,
  ) => ({
    attempt: attemptNumber,
    is_valid: isValidEntry,
    timestamp: new Date().toISOString(),
    transcript: transcriptText,
    validation_message: validationMsg,
  });

  const normalizeAttemptHistory = (attempts: any) => {
    if (Array.isArray(attempts)) return attempts;

    if (typeof attempts === 'string') {
      const candidates = [attempts];
      let current = attempts.trim();

      // Some records were saved as repeatedly stringified JSON. Peel those layers back.
      while (current.startsWith('"') && current.endsWith('"')) {
        try {
          current = JSON.parse(current);
          candidates.push(current);
        } catch {
          break;
        }
      }

      try {
        const parsed = JSON.parse(current);
        if (Array.isArray(parsed)) return parsed;
      } catch {
        // Fall through to the raw string wrapper below.
      }

      return candidates;
    }

    return [];
  };

  const getAttemptHistory = (record: any) => {
    const history = record?.post_transcript_attempts
      ?? record?.assessmentPostTranscriptAttempts
      ?? record?.updatedData?.post_transcript_attempts
      ?? record?.updatedData?.assessmentPostTranscriptAttempts;

    return normalizeAttemptHistory(history);
  };

  const parseMaybeJson = (value: any) => {
    if (typeof value !== 'string') return value;

    try {
      return JSON.parse(value);
    } catch {
      return value;
    }
  };

  const getPreTranscript = (record: any) =>
    record?.pre_transcript
    ?? record?.assessmentPreTranscript
    ?? record?.updatedData?.pre_transcript
    ?? record?.updatedData?.assessmentPreTranscript;

  const getPostTranscript = (record: any) =>
    record?.post_transcript
    ?? record?.assessmentPostTranscript
    ?? record?.updatedData?.post_transcript
    ?? record?.updatedData?.assessmentPostTranscript;

  const validationPrompt =
    data?.ValidationPrompt
    ?? formData?.ValidationPrompt
    ?? learnerPlayList?.ValidationPrompt;

  const evaluationPrompt =
    data?.EvaluationPrompt
    ?? formData?.EvaluationPrompt
    ?? learnerPlayList?.EvaluationPrompt;

  const getEvaluationJson = (record: any) =>
    parseMaybeJson(
      record?.evaluation_json
      ?? record?.assessmentEvaluationJson
      ?? record?.updatedData?.evaluation_json
      ?? record?.updatedData?.assessmentEvaluationJson
    );

  const normalizeEvaluationResponse = (response: any) => {
    const payload = response?.data ?? response?.updatedData ?? response;
    return getEvaluationJson(payload) ?? parseMaybeJson(payload);
  };

  const autoSubmitIfFinalAttempt = async (attemptNumber: number, assessmentIdToUse: string) => {
    if (attemptNumber >= 3) {
      lastSavedAssessmentIdRef.current = assessmentIdToUse;
      setShowSubmitButton(true);
      setTimeout(() => handleSubmitCore(assessmentIdToUse), 1500);
      return true;
    }

    return false;
  };


 const processRecording = async (audioBlob: Blob): Promise<boolean> => {
    if (!session) return false;

    setIsProcessing(true);
    setProcessingProgress(0);
    setProcessingStage('transcribing');

    try {
      // Step 1: Convert audio blob to base64
      setProcessingProgress(5);
      const reader = new FileReader();
      const base64Audio = await new Promise<string>((resolve, reject) => {
        reader.onloadend = () => {
          const base64 = (reader.result as string).split(',')[1];
          resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(audioBlob);
      });
      setProcessingProgress(20);

      // Step 2: STT
      const sttResponse = await assessmentStt({
        audio: base64Audio,
        gameId: session.gameId,
        phase: 'post'
      });
      setProcessingProgress(50);
      // Check if STT API returned 500
      const isSttFailed = sttResponse?.status === 500;

      if (sttResponse?.error) throw new Error(sttResponse.error.message);

    const sttData = sttResponse?.data ?? sttResponse;
    // const transcriptText = String(sttData?.transcript ?? '');
     //const transcriptText = String(sttData?.transcript?.trim()? sttData.transcript: "You don't record anything");
      const transcriptText = isSttFailed ? "api failed" : String(sttData?.transcript?.trim() ? sttData.transcript : "You don't record anything");
    const word_count = Number(sttData?.word_count ?? 0);

      // Check for minimum word count
      if (word_count < 10) {
        const message = `Your response is too short (${word_count} words). Please provide at least 10 words.`;

        setTranscript(transcriptText);
        setWordCount(word_count);
        setIsValid(false);
        setValidationMessage(message);
        const newAttempts = attempts + 1;
        setAttempts(newAttempts);
      setlearnerActivityrec((prev:any)=>
          updatePostAssessmentBlock(
            prev,
            {
              blockId:data.blockId,
              attempt:newAttempts,
              transcript:transcriptText,
              is_valid:false,
              validation_message:message
            },
            deviceInfo
          )
        );
        // Fetch existing attempts and save to DB
       
        const assessmentIdToUse = session.assessmentId;
        const existingData = (await assessmentGet(assessmentIdToUse))?.updatedData;
       

        const nextAttemptEntry = buildAttemptEntry(
          // newAttempts, transcriptText, false, message
         newAttempts,
          isSttFailed ? "STT service unavailable" : transcriptText,
          false,
          isSttFailed ? "STT service unavailable" : message
        );
        const newAttemptsArray = [...getAttemptHistory(existingData), nextAttemptEntry];

        const shortUpdateResult = await assessmentUpdate(
          {
            post_transcript: transcriptText,
            post_valid: false,
            assessmentPostValid: false,
            post_attempts: newAttempts,
          post_transcript_attempts: newAttemptsArray,
          assessmentPostTranscriptAttempts: newAttemptsArray,
          evaluation_json: null,
          delta: null,
        },
        assessmentIdToUse
      );
        lastSavedAssessmentIdRef.current = assessmentIdToUse;
     
        if (shortUpdateResult?.status === 'Error') {
          console.error('Failed to save short post transcript:', shortUpdateResult);
          toast.error('Transcript was transcribed but could not be saved.');
        }
                              let getscoreseq: any = [];
      let updatedscore: any = [];
      if (questState[parseInt(profile?.currentQuest)] === 'Started') {
        // Remove matching object from profile?.score
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      } else if (
        questState[parseInt(profile?.currentQuest)] === 'replayallowed'
      ) {
        // Remove matching object from profile?.replayScore
        getscoreseq = profile?.replayScore?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.replayScore;
      } else {
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      }
      const foundOption = getscoreseq;

      const foundOnlyOption = getscoreseq?.choosedoption;
      let total = 0;
      const scoreArray = updatedscore;

      if (scoreArray?.length > 0) {
        // STEP 2: Apply filter with logs
        const filteredData = scoreArray?.filter((cur: any, index: number) => {
          const isValidStructure =
            cur.seqId &&
            cur.scenarioId !== undefined &&
            cur.choosedoption !== undefined;

          const isQuestMatch =
            Number(cur.quest) === Number(profile.currentQuest);

          const finalResult = isValidStructure && isQuestMatch;

          return finalResult;
        });

        // STEP 3: Reduce with logs
        total = filteredData?.reduce((sum: number, cur: any, index: number) => {
          const score = Number(cur.score || 0);

          return sum + score;
        }, 0);
      }
            const conditionTypes = ['Interaction', 'response', 'feedback'];
      const updatedata = {
        galAssignedId:AssignId,
        blockname: data?.blockChoosen,
        galAverageScore: total,
        galBlockId: data?.blockSecondaryId,
        galblockleft : data?.blockSecondaryId,
        gameId: learner_game_play_id,
        galTimeSpent: seconds,
      };
 const actId1 = Activitydata;
      const datas = JSON.stringify(updatedata)
      const result = await activityUpdate(datas, actId1);
        // Create separate histData for this response
        const histData: any = {
          // histActivityId: session.assessmentId,
          histActivityId:  result?.updatedData?.galId,
          histGameId: session.gameId,
          histQuestNo: currentQuestNo,
          histBlockId: result?.updatedData?.galBlockId,
          // histBlockId: session.assessmentId,
          histType: 'PostAssessment',
          histNavigateTo: 'retry',
          histOption: null as string | null,
          // histScore: 0,
          // histPostAssessmentScore: 0
        };
        
        if (newAttempts === 1) {
          histData.histpostassessmentresponse1 = transcriptText;
        } else if (newAttempts === 2) {
          histData.histpostassessmentresponse2 = transcriptText;
        } else if (newAttempts === 3) {
          histData.histpostassessmentresponse3 = transcriptText;
        }
        
        try {
          const historyResult = await createGamePlayHistory(JSON.stringify(histData));
       
        } catch (histError) {
          console.error('Failed to create short response history:', histError);
        }

        await autoSubmitIfFinalAttempt(newAttempts, assessmentIdToUse);

        setIsProcessing(false);
        setProcessingProgress(0);
        return false;
      }

      setTranscript(transcriptText);
      setWordCount(word_count);

      // Step 3: Validation
      setProcessingStage('validating');
      setProcessingProgress(60);
     
      const validateResponse = await assessmentValidate({ 
        gameId: session.gameId, 
        phase: 'post', 
        transcript: transcriptText,
        data: { ValidationPrompt: validationPrompt }
      });
      setProcessingProgress(75);

    if (validateResponse.error) throw new Error(validateResponse.error.message);

    const validationResult = validateResponse?.data ?? validateResponse;
    const valid = validationResult.valid === true;
    const validationMsg = valid
      ? validationResult.validation_comment || 'Great job!'
      : validationResult.correction_nudge || 'Please try to provide more specific feedback.';

    setIsValid(valid);
    setValidationMessage(validationMsg);

    const newAttempts = attempts + 1;
    setAttempts(newAttempts);
  setlearnerActivityrec((prev:any)=>
      updatePostAssessmentBlock(
        prev,
        {
          blockId:data.blockId,

          attempt:newAttempts,

          transcript:transcriptText,

          is_valid:valid,

          validation_message:validationMsg
        },
        deviceInfo
      )
    );
   
    const assessmentIdToUse = session.assessmentId;
    const existingData = (await assessmentGet(assessmentIdToUse))?.updatedData;
   

      const nextAttemptEntry = buildAttemptEntry(newAttempts, transcriptText, valid, validationMsg);
      const newAttemptsArray = [...getAttemptHistory(existingData), nextAttemptEntry];

      // Save to database
      setProcessingStage('saving');
      setProcessingProgress(85);
      const updateResult = await assessmentUpdate(
        {
          post_transcript: transcriptText,
          post_valid: Boolean(valid),
          assessmentPostValid: Boolean(valid),
          post_attempts: newAttempts,
          post_transcript_attempts: newAttemptsArray,
          assessmentPostTranscriptAttempts: newAttemptsArray,
          evaluation_json: null,
          delta: null,
        },
        assessmentIdToUse
      );
      lastSavedAssessmentIdRef.current = assessmentIdToUse;
    
      if (updateResult?.status === 'Error') {
        console.error('Failed to save post transcript:', updateResult);
        toast.error('Transcript was transcribed but could not be saved.');
        throw new Error(updateResult.message);
      }
                              let getscoreseq: any = [];
      let updatedscore: any = [];
      if (questState[parseInt(profile?.currentQuest)] === 'Started') {
        // Remove matching object from profile?.score
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      } else if (
        questState[parseInt(profile?.currentQuest)] === 'replayallowed'
      ) {
        // Remove matching object from profile?.replayScore
        getscoreseq = profile?.replayScore?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.replayScore;
      } else {
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      }
      const foundOption = getscoreseq;

      const foundOnlyOption = getscoreseq?.choosedoption;
      let total = 0;
      const scoreArray = updatedscore;

      if (scoreArray?.length > 0) {
        // STEP 2: Apply filter with logs
        const filteredData = scoreArray?.filter((cur: any, index: number) => {
          const isValidStructure =
            cur.seqId &&
            cur.scenarioId !== undefined &&
            cur.choosedoption !== undefined;

          const isQuestMatch =
            Number(cur.quest) === Number(profile.currentQuest);

          const finalResult = isValidStructure && isQuestMatch;

          return finalResult;
        });

        // STEP 3: Reduce with logs
        total = filteredData?.reduce((sum: number, cur: any, index: number) => {
          const score = Number(cur.score || 0);

          return sum + score;
        }, 0);
      }
            const conditionTypes = ['Interaction', 'response', 'feedback'];
      const updatedata = {
        galAssignedId:AssignId,
        blockname: data?.blockChoosen,
        galAverageScore: total,
        galBlockId: data?.blockSecondaryId,
        galblockleft : data?.blockSecondaryId,
        gameId: learner_game_play_id,
        galTimeSpent: seconds,
      };
 const actId1 = Activitydata;
      const datas = JSON.stringify(updatedata)
      const result = await activityUpdate(datas, actId1);
      // Create separate histData for this response
      const histData: any = {
        // histActivityId: session.assessmentId,
        histActivityId:  result?.updatedData?.galId,
        histGameId: session.gameId,
        histQuestNo: currentQuestNo,
        // histBlockId: session.assessmentId,
        histBlockId: result?.updatedData?.galBlockId,
        histType: 'PostAssessment',
        histNavigateTo: valid ? 'evaluation' : 'retry',
        histOption: null as string | null,
        // histScore: valid ? 100 : 0,
        // histPostAssessmentScore: valid ? 10 : 0
      };
      
      if (newAttempts === 1) {
        histData.histpostassessmentresponse1 = transcriptText;
      } else if (newAttempts === 2) {
        histData.histpostassessmentresponse2 = transcriptText;
      } else if (newAttempts === 3) {
        histData.histpostassessmentresponse3 = transcriptText;
      }
      
      try {
        const historyResult = await createGamePlayHistory(JSON.stringify(histData));
       
      } catch (histError) {
        console.error('Failed to create assessment history:', histError);
      }

      setProcessingProgress(100);

      if (valid || newAttempts >= 3) {
        setShowSubmitButton(true);
        await autoSubmitIfFinalAttempt(newAttempts, assessmentIdToUse);
      } else {
        setShowSubmitButton(false);
        toast.info('Please review the feedback and try again.');
      }

      return valid;
    } catch (error) {
      console.error('Error processing recording:', error);
      toast.error('Failed to process recording');
      return false;
    } finally {
      setIsProcessing(false);
      setTimeout(() => setProcessingProgress(0), 500);
    }
  };
  const handleSubmit = async () => {
    await handleSubmitCore();
  };

  const handleSubmitCore = async (assessmentIdOverride?: string) => {
    if (!session) return;
    const assessmentIdToUse = assessmentIdOverride || lastSavedAssessmentIdRef.current || session.assessmentId;

   
    setShowSubmitButton(false);

    try {
      // Verify the transcript exists in the same assessment row that was just saved
      const assessmentResult = await assessmentGet(assessmentIdToUse);
      const data = assessmentResult?.updatedData;

      if (!getPostTranscript(data)) {
        toast.error('Please wait for processing to complete');
        setShowSubmitButton(true);
        return;
      }

      setValidationMessage('');
      setShowSuccessOverlay(true);

      setTimeout(async () => {
        setShowSuccessOverlay(false);
        setShowEvaluationLoading(true);
        await runEvaluation(assessmentIdToUse);
      }, 3000);
    } catch (error) {
      console.error('Error verifying transcript:', error);
      toast.error('Failed to submit. Please try again.');
      setShowSubmitButton(true);
    }
  };

  const runEvaluation = async (assessmentIdToUse?: string) => {
    if (!session) return;
    const finalAssessmentId = assessmentIdToUse || lastSavedAssessmentIdRef.current || session.assessmentId;

    try {
     
      const assessmentResult = await assessmentGet(finalAssessmentId);
      const assessmentData = assessmentResult?.updatedData;
      const preTranscript = getPreTranscript(assessmentData);
      const postTranscript = getPostTranscript(assessmentData);

      // if (!preTranscript || !postTranscript) {
      //   toast.error('Please wait for processing to complete');
      //   setShowEvaluationLoading(false);
      //   return;
      // }

      const evaluateResponse = await assessmentEvaluate({
        assessment_id: finalAssessmentId,
        pre_transcript: preTranscript,
        post_transcript: postTranscript,
        data: { EvaluationPrompt: evaluationPrompt }
      });

      if (evaluateResponse.error) {
        const errorMsg = evaluateResponse.error.message || '';

        if (errorMsg.includes('transcripts are required')) {
          toast.error('Your response is still being processed. Please wait a moment and try again.');
        } else {
          toast.error('Failed to evaluate responses. Please try again.');
        }
        throw new Error(errorMsg);
      }

      setShowEvaluationLoading(false);

      const responseEvaluation = normalizeEvaluationResponse(evaluateResponse);
      if (responseEvaluation?.pre_assessment || responseEvaluation?.post_assessment) {
        await assessmentUpdate({
          evaluation_json: responseEvaluation,
          assessmentEvaluationJson: responseEvaluation,
          delta: responseEvaluation?.delta ?? responseEvaluation?.comparison?.score_difference ?? null,
        }, finalAssessmentId);
      }

      // Load evaluation results and show them inline, matching the backup flow.
      const refreshedAssessment = await assessmentGet(finalAssessmentId);
      const refreshedData = refreshedAssessment?.updatedData;
      const evaluationPayload =
        getEvaluationJson(refreshedData)
        ?? responseEvaluation;
      if (!evaluationPayload) {
        toast.error('Failed to load evaluation results.');
        return;
      }

      setEvaluationData(evaluationPayload);
      setShowResults(true);
      setlearnerActivityrec((prev:any)=>
        updatePostAssessmentBlock(
          prev,
          {
            blockId:data.blockId,
            attempt:attempts,
            transcript:getPostTranscript(assessmentData),
            is_valid:true,
            validation_message:"Evaluation completed",
            evaluation:evaluationPayload
          },
          deviceInfo
        )
      );
      toast.success('Evaluation complete!');

      // Store evaluation_json in history
      if (evaluationPayload) {
                                   let getscoreseq: any = [];
      let updatedscore: any = [];
      if (questState[parseInt(profile?.currentQuest)] === 'Started') {
        // Remove matching object from profile?.score
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      } else if (
        questState[parseInt(profile?.currentQuest)] === 'replayallowed'
      ) {
        // Remove matching object from profile?.replayScore
        getscoreseq = profile?.replayScore?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.replayScore;
      } else {
        getscoreseq = profile?.score?.find(
          (item: any) => item?.seqId == data?.blockPrimarySequence,
        );
        updatedscore = profile?.score;
      }
      const foundOption = getscoreseq;

      const foundOnlyOption = getscoreseq?.choosedoption;
      let total = 0;
      const scoreArray = updatedscore;

      if (scoreArray?.length > 0) {
        // STEP 2: Apply filter with logs
        const filteredData = scoreArray?.filter((cur: any, index: number) => {
          const isValidStructure =
            cur.seqId &&
            cur.scenarioId !== undefined &&
            cur.choosedoption !== undefined;

          const isQuestMatch =
            Number(cur.quest) === Number(profile.currentQuest);

          const finalResult = isValidStructure && isQuestMatch;

          return finalResult;
        });

        // STEP 3: Reduce with logs
        total = filteredData?.reduce((sum: number, cur: any, index: number) => {
          const score = Number(cur.score || 0);

          return sum + score;
        }, 0);
      }
            const conditionTypes = ['Interaction', 'response', 'feedback'];
      const updatedata = {
        blockname: data?.blockChoosen,
        galAverageScore: total,
        galBlockId: data?.blockSecondaryId,
        galblockleft : data?.blockSecondaryId,
        gameId: learner_game_play_id,
        galTimeSpent: seconds,
      };
 const actId1 = Activitydata;
      const datas = JSON.stringify(updatedata)
        const result = await activityUpdate(datas, actId1);
        
      
        
      const histData: any = {
          histActivityId: result?.updatedData?.galId,
          histGameId: session.gameId,
          histQuestNo: currentQuestNo,
          histBlockId: result?.updatedData?.galBlockId,
          histType: 'PostAssessment',
          histNavigateTo: 'evaluation',
          histEvaluation_json: JSON.stringify(evaluationPayload),
          histPostAssessmentScore:evaluationPayload?.post_assessment?.total,
          histPreAssessmentScore:evaluationPayload?.pre_assessment?.total
        };
     
        
        try {
          const historyResult = await createGamePlayHistory(JSON.stringify(histData));
          const responseData = historyResult?.histEvaluation_json || histData.histEvaluation_json;

          if (responseData) {
            localStorage.setItem("postAssestment", responseData);
          }
        } catch (histError) {
          console.error('Failed to save evaluation history:', histError);
        }
        onComplete?.(); // Notify parent that assessment is complete
      }
    } catch (error) {
      console.error('Error running evaluation:', error);
      setShowEvaluationLoading(false);
    }
  };
  let responsedata = null;

  const storedData = localStorage.getItem("postAssestment");

  if (storedData) {
    try {
      responsedata = JSON.parse(storedData);
    } catch {
      responsedata = null;
    }
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-background-start to-background-end flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-white-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!session) {
    return null;
  }
  const evaluation = showResults ? (evaluationData || responsedata) : responsedata;

  // Show results inline when evaluation is complete, matching the backup flow.
  if (evaluation) {
    return (
      <div className="space-y-4">
        <EvaluationResults
          evaluation={evaluation}
          assessmentId={session.assessmentId}
          learnerName={session.learnerName}
          data={data}
          contentByLanguage={contentByLanguage}
        />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-background-start to-background-end relative">
      <div className="max-w-7xl mx-auto">
        <div className="min-h-[calc(100vh-22rem)] flex items-start md:items-center">
          <div className="grid md:grid-cols-2 gap-6 w-full">
            <div className="space-y-4">
              <ScenarioCard data={data} type={"post"} contentByLanguage={contentByLanguage} />
              <RecordingInstructions />
            </div>

            <div className="space-y-6">
              <AudioRecorder
                maxDuration={120}
                hideRerecord={false}
                onRecordingComplete={handleRecordingComplete}
                onStopRecording={handleRecordingStop}
                onRecordingStart={() => setValidationMessage('')}
                onRecordingStateChange={(recording) => setIsCurrentlyRecording(recording)}
                disabled={isProcessing || isSubmitting}
                attemptCount={attempts}
                isValidating={isProcessing}
              />

              <TranscriptCard
                transcript={transcript}
                wordCount={wordCount}
                isValid={isValid}
                validationMessage={validationMessage}
                isProcessing={isProcessing}
                processingStage={processingStage}
                attemptCount={attempts}
                maxAttempts={3}
                processingProgress={processingProgress}
              />

              <Button
                onClick={handleSubmit}
                className={`text-lg w-full ${showSubmitButton && !isProcessing && !isSubmitting && !isCurrentlyRecording ? 'dark:submit-glow-active' : ''}`}
                size="lg"
                disabled={!showSubmitButton || isProcessing || isSubmitting || isCurrentlyRecording}
                 style={{
                  // fontSize: "16px" ,
    backgroundColor: primaryColor || undefined,
    background: primaryColor 
      ? `linear-gradient(145deg, 
          ${primaryColor} 0%, 
          ${primaryColor}E6 30%, 
          ${primaryColor}CC 70%, 
          ${primaryColor} 100%
        )` 
      : undefined,
    border: primaryColor ? '1px solid rgba(255, 255, 255, 0.3)' : undefined,
    boxShadow: primaryColor 
      ? `0 10px 30px rgba(0, 0, 0, 0.2),
         inset 0 1px 0 rgba(255, 255, 255, 0.4),
         inset 0 -1px 0 rgba(0, 0, 0, 0.1)`
      : undefined,
    color: primaryColor ? 'white' : undefined,
    opacity: (!showSubmitButton || isProcessing || isSubmitting || isCurrentlyRecording) ? 0.5 : 1,
    transition: 'all 0.2s ease',
  }}
                variant={isValid && showSubmitButton ? 'default' : 'secondary'}
              >
                Submit Recording
              </Button>

              {/* <Card>
                <CardContent className="p-4">
                  <div className="space-y-2 text-lg">
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">Session ID:</span>
                      <span className="font-mono">{session.gameId}</span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-muted-foreground">Learner:</span>
                      <span className="font-medium">{session.learnerName}</span>
                    </div>
                  </div>
                </CardContent>
              </Card> */}
            </div>
          </div>
        </div>
      </div>

      <SuccessOverlay
        show={showSuccessOverlay}
        message="Thanks for your response!"
        variant="success"
      />

      <SuccessOverlay
        show={showEvaluationLoading}
        message="Analysing your response"
        variant="loading"
      />
    </div>
  );
};

export default PostTraining;
